import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';
import { getUnixTime } from 'date-fns';

export default Factory.extend({
  name: () => faker.lorem.word(),
  createdBy: null,
  lastUpdatedBy: null,
  versionNumber: () => faker.number.int(),
  createdAt: getUnixTime(new Date()),
  publishedAt: null,
});
